import { render, staticRenderFns } from "./AcceptEventModal.vue?vue&type=template&id=6b4183d4&scoped=true&"
import script from "./AcceptEventModal.vue?vue&type=script&lang=js&"
export * from "./AcceptEventModal.vue?vue&type=script&lang=js&"
import style0 from "./AcceptEventModal.vue?vue&type=style&index=0&id=6b4183d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4183d4",
  null
  
)

export default component.exports